<div class="yt-page">

  <!-- Header -->
  <div class="page-header">
    <div class="page-header-left">
      <span class="material-icons yt-icon">smart_display</span>
      <div>
        <h1 class="page-title">YouTube Monitoring</h1>
        <div class="page-sub">Public video and comment monitoring for PULSE, PLRA, land record and mutation mentions</div>
      </div>
    </div>
    <div class="header-actions">
      <span class="sync-result" *ngIf="syncResult">{{ syncResult }}</span>
      <button class="yt-btn" (click)="syncNow()" [disabled]="syncing">
        <span class="material-icons">{{ syncing ? 'hourglass_empty' : 'sync' }}</span>
        {{ syncing ? 'Syncing...' : 'Sync Now' }}
      </button>
    </div>
  </div>

  <!-- Stats -->
  <section class="stats-grid">
    <div class="stat-card">
      <span class="material-icons">smart_display</span>
      <strong>{{ stats.totalVideos }}</strong>
      <label>Videos found</label>
    </div>
    <div class="stat-card">
      <span class="material-icons">comment</span>
      <strong>{{ stats.totalComments }}</strong>
      <label>Comments collected</label>
    </div>
    <div class="stat-card stat-risk">
      <span class="material-icons">warning</span>
      <strong>{{ stats.highRisk }}</strong>
      <label>High risk</label>
    </div>
    <div class="stat-card stat-negative">
      <span class="material-icons">sentiment_dissatisfied</span>
      <strong>{{ stats.negative }}</strong>
      <label>Negative</label>
    </div>
    <div class="stat-card stat-positive">
      <span class="material-icons">sentiment_satisfied</span>
      <strong>{{ stats.positive }}</strong>
      <label>Positive</label>
    </div>
    <div class="stat-card stat-complaint">
      <span class="material-icons">report_problem</span>
      <strong>{{ stats.complaints }}</strong>
      <label>Complaints</label>
    </div>
    <div class="stat-card stat-whitelist" (click)="showWhitelisted()" style="cursor:pointer">
      <span class="material-icons">verified</span>
      <strong>{{ stats.whitelisted }}</strong>
      <label>Whitelisted</label>
    </div>
    <div class="stat-card stat-blacklist" (click)="showBlacklisted()" style="cursor:pointer">
      <span class="material-icons">block</span>
      <strong>{{ stats.blacklisted }}</strong>
      <label>Blacklisted</label>
    </div>
  </section>

  <!-- Top Trends -->
  <section class="trends-strip" *ngIf="stats.topTrends.length">
    <span class="trend-title"><span class="material-icons">trending_up</span> Top Trends</span>
    <button class="trend-chip" *ngFor="let t of stats.topTrends" (click)="vFilterQ = t.trendTopic; applyVideoFilters()">
      {{ t.trendTopic }} <strong>{{ t.count }}</strong>
    </button>
  </section>

  <!-- Error -->
  <div class="error-bar" *ngIf="errorMessage">{{ errorMessage }}</div>

  <!-- Tabs -->
  <div class="tabs">
    <button class="tab-btn" [class.active]="activeTab === 'videos'" (click)="switchTab('videos')">
      <span class="material-icons">video_library</span> Videos ({{ stats.totalVideos }})
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'comments'" (click)="switchTab('comments')">
      <span class="material-icons">forum</span> Comments ({{ stats.totalComments }})
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'config'" (click)="switchTab('config')">
      <span class="material-icons">tune</span> Settings
    </button>
  </div>

  <!-- ── VIDEOS TAB ── -->
  <div *ngIf="activeTab === 'videos'">
    <div class="filter-bar">
      <select class="yt-input" [(ngModel)]="vFilterSentiment">
        <option value="">All sentiments</option>
        <option value="NEGATIVE">Negative</option>
        <option value="NEUTRAL">Neutral</option>
        <option value="POSITIVE">Positive</option>
      </select>
      <select class="yt-input" [(ngModel)]="vFilterRisk">
        <option value="">All risk</option>
        <option value="CRITICAL">Critical</option>
        <option value="HIGH">High</option>
        <option value="MEDIUM">Medium</option>
        <option value="LOW">Low</option>
      </select>
      <select class="yt-input" [(ngModel)]="vFilterStatus">
        <option value="">All statuses</option>
        <option value="OPEN">Open</option>
        <option value="REVIEW">Review</option>
        <option value="CLOSED">Closed</option>
      </select>
      <select class="yt-input" [(ngModel)]="vFilterWhitelisted">
        <option value="">All videos</option>
        <option value="true">Whitelisted only</option>
      </select>
      <select class="yt-input" [(ngModel)]="vFilterBlacklisted">
        <option value="">Hide blacklisted</option>
        <option value="true">Blacklisted only</option>
      </select>
      <input class="yt-input" type="date" [(ngModel)]="vFilterFrom" />
      <input class="yt-input" type="date" [(ngModel)]="vFilterTo" />
      <input class="yt-input search" [(ngModel)]="vFilterQ" placeholder="Search title, channel..."
             (keydown.enter)="applyVideoFilters()" />
      <button class="yt-btn yt-btn-accent" (click)="applyVideoFilters()">Search</button>
      <button class="yt-btn" (click)="clearVideoFilters()">Clear</button>
    </div>

    <div class="content-card">
      <div class="card-header">
        <span>{{ videoTotal }} videos</span>
        <small>{{ vPageStart }}-{{ vPageEnd }} shown</small>
      </div>

      <div class="empty" *ngIf="videosLoading">Loading YouTube videos...</div>
      <div class="empty" *ngIf="!videosLoading && videos.length === 0">No videos match the current filters</div>

      <table class="data-table" *ngIf="!videosLoading && videos.length">
        <thead>
          <tr>
            <th>Video</th>
            <th>Channel</th>
            <th>Keywords</th>
            <th>Trend</th>
            <th>Sentiment</th>
            <th>Risk</th>
            <th>Published</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let v of videos">
            <tr (click)="toggleVideo(v.id)" tabindex="0" (keydown.enter)="toggleVideo(v.id)"
                [class.row-whitelisted]="v.isWhitelisted" [class.row-blacklisted]="v.isBlacklisted">
              <td class="video-cell">
                <img *ngIf="v.thumbnailUrl" [src]="v.thumbnailUrl" class="thumbnail" alt="" />
                <div class="video-meta">
                  <span class="video-title">{{ v.title | slice:0:70 }}{{ (v.title?.length ?? 0) > 70 ? '...' : '' }}</span>
                  <div class="video-flags">
                    <span class="flag-badge flag-wl" *ngIf="v.isWhitelisted">
                      <span class="material-icons">verified</span> Whitelisted
                    </span>
                    <span class="flag-badge flag-bl" *ngIf="v.isBlacklisted">
                      <span class="material-icons">block</span> Blacklisted
                    </span>
                  </div>
                  <small>{{ v.viewCount ?? 0 | number }} views</small>
                </div>
              </td>
              <td>{{ v.channelTitle || '-' }}</td>
              <td><span class="tag-chip">{{ v.matchedKeywords || '-' }}</span></td>
              <td><span class="tag-chip">{{ v.trendTopic || '-' }}</span></td>
              <td><span class="badge" [ngClass]="sentimentClass(v.sentimentLabel)">{{ cleanLabel(v.sentimentLabel) }}</span></td>
              <td><span class="badge" [ngClass]="riskClass(v.riskLevel)">{{ v.riskLevel || '-' }}</span></td>
              <td>{{ formatDate(v.publishedAt) }}</td>
              <td class="actions" (click)="$event.stopPropagation()">
                <button class="yt-btn tiny" (click)="filterByVideo(v.videoId)">Comments</button>
                <button class="yt-btn tiny" (click)="updateVideoStatus(v, 'REVIEW', $event)">Review</button>
                <button class="yt-btn tiny" (click)="updateVideoStatus(v, 'CLOSED', $event)">Close</button>
                <button class="yt-btn tiny btn-wl" [class.active]="v.isWhitelisted"
                        (click)="toggleWhitelist(v, $event)"
                        [title]="v.isWhitelisted ? 'Remove from whitelist' : 'Whitelist — always include, skip geo-filter'">
                  <span class="material-icons">{{ v.isWhitelisted ? 'verified' : 'verified_outlined' }}</span>
                </button>
                <button class="yt-btn tiny btn-bl" [class.active]="v.isBlacklisted"
                        (click)="toggleBlacklist(v, $event)"
                        [title]="v.isBlacklisted ? 'Remove from blacklist' : 'Blacklist — hide permanently, skip future syncs'">
                  <span class="material-icons">{{ v.isBlacklisted ? 'block' : 'do_not_disturb_alt' }}</span>
                </button>
              </td>
            </tr>
            <tr class="expand-row" *ngIf="expandedVideoId === v.id">
              <td colspan="8">
                <div class="expand-grid">
                  <div>
                    <label>Full title</label>
                    <p>{{ v.title }}</p>
                  </div>
                  <div>
                    <label>Watch on YouTube</label>
                    <a *ngIf="v.videoUrl" [href]="v.videoUrl" target="_blank" rel="noopener">Open video</a>
                  </div>
                  <div>
                    <label>Last synced</label>
                    <p>{{ formatDate(v.lastSyncedAt) }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <div class="pagination" *ngIf="videoTotal > 0">
        <button class="yt-btn" [disabled]="videoPage === 0" (click)="prevVideos()">Previous</button>
        <span>Page {{ videoPage + 1 }} / {{ videoTotalPages || 1 }}</span>
        <button class="yt-btn" [disabled]="videoPage >= videoTotalPages - 1" (click)="nextVideos()">Next</button>
      </div>
    </div>
  </div>

  <!-- ── COMMENTS TAB ── -->
  <div *ngIf="activeTab === 'comments'">
    <div class="filter-bar">
      <input class="yt-input" [(ngModel)]="cFilterVideoId" placeholder="Filter by video ID..." />
      <select class="yt-input" [(ngModel)]="cFilterSentiment">
        <option value="">All sentiments</option>
        <option value="NEGATIVE">Negative</option>
        <option value="NEUTRAL">Neutral</option>
        <option value="POSITIVE">Positive</option>
      </select>
      <select class="yt-input" [(ngModel)]="cFilterIntent">
        <option value="">All intents</option>
        <option value="COMPLAINT">Complaint</option>
        <option value="INQUIRY">Inquiry</option>
        <option value="APPRECIATION">Appreciation</option>
        <option value="MENTION">Mention</option>
      </select>
      <select class="yt-input" [(ngModel)]="cFilterRisk">
        <option value="">All risk</option>
        <option value="CRITICAL">Critical</option>
        <option value="HIGH">High</option>
        <option value="MEDIUM">Medium</option>
        <option value="LOW">Low</option>
      </select>
      <input class="yt-input" type="date" [(ngModel)]="cFilterFrom" />
      <input class="yt-input" type="date" [(ngModel)]="cFilterTo" />
      <input class="yt-input search" [(ngModel)]="cFilterQ" placeholder="Search comment, author..."
             (keydown.enter)="applyCommentFilters()" />
      <button class="yt-btn yt-btn-accent" (click)="applyCommentFilters()">Search</button>
      <button class="yt-btn" (click)="clearCommentFilters()">Clear</button>
      <button class="yt-btn" (click)="reanalyzeComments()" [disabled]="reanalyzing"
              title="Re-run sentiment, intent and risk analysis on all stored comments">
        <span class="material-icons">{{ reanalyzing ? 'hourglass_empty' : 'psychology' }}</span>
        {{ reanalyzing ? 'Analyzing...' : 'Reanalyze All' }}
      </button>
      <span *ngIf="reanalyzeResult" style="font-size:13px;font-weight:700;color:var(--csr-accent)">{{ reanalyzeResult }}</span>
    </div>

    <div class="content-card">
      <div class="card-header">
        <span>{{ commentTotal }} comments</span>
        <small>{{ cPageStart }}-{{ cPageEnd }} shown · click a row for full detail</small>
      </div>

      <div class="empty" *ngIf="commentsLoading">Loading comments...</div>
      <div class="empty" *ngIf="!commentsLoading && comments.length === 0">No comments match the current filters</div>

      <table class="data-table" *ngIf="!commentsLoading && comments.length">
        <thead>
          <tr>
            <th>Comment</th>
            <th>Author</th>
            <th>Keywords</th>
            <th>Sentiment</th>
            <th>Intent</th>
            <th>Risk</th>
            <th>Published</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let c of comments">
            <tr (click)="toggleComment(c.id)" tabindex="0" (keydown.enter)="toggleComment(c.id)"
                style="cursor:pointer">
              <td class="comment-text" dir="auto">
                {{ c.commentText | slice:0:140 }}{{ c.commentText.length > 140 ? '...' : '' }}
              </td>
              <td>{{ c.authorName || '-' }}</td>
              <td><span class="tag-chip" *ngIf="c.matchedKeywords">{{ c.matchedKeywords }}</span><span *ngIf="!c.matchedKeywords">-</span></td>
              <td>
                <span class="badge" [ngClass]="sentimentClass(c.sentimentLabel)">{{ cleanLabel(c.sentimentLabel) }}</span>
                <small>{{ scoreText(c.sentimentScore) }}</small>
              </td>
              <td><span class="badge intent">{{ cleanLabel(c.intentLabel) }}</span></td>
              <td><span class="badge" [ngClass]="riskClass(c.riskLevel)">{{ c.riskLevel || '-' }}</span></td>
              <td>{{ formatDate(c.publishedAt) }}</td>
              <td class="actions" (click)="$event.stopPropagation()">
                <button class="yt-btn tiny" (click)="updateCommentStatus(c, 'REVIEW')">Review</button>
                <button class="yt-btn tiny" (click)="updateCommentStatus(c, 'CLOSED')">Close</button>
              </td>
            </tr>
            <tr class="expand-row" *ngIf="expandedCommentId === c.id">
              <td colspan="8">
                <div class="expand-grid" style="grid-template-columns: 2fr 1fr 1fr">
                  <div>
                    <label>Full comment</label>
                    <p dir="auto" style="white-space:pre-wrap;line-height:1.6">{{ c.commentText }}</p>
                  </div>
                  <div>
                    <label>Sentiment</label>
                    <p><span class="badge" [ngClass]="sentimentClass(c.sentimentLabel)">{{ cleanLabel(c.sentimentLabel) }}</span>
                    &nbsp;<small>{{ scoreText(c.sentimentScore) }}</small></p>
                    <label style="margin-top:12px">Intent</label>
                    <p><span class="badge intent">{{ cleanLabel(c.intentLabel) }}</span></p>
                    <label style="margin-top:12px">Risk</label>
                    <p><span class="badge" [ngClass]="riskClass(c.riskLevel)">{{ c.riskLevel || '-' }}</span>
                    &nbsp;<small>score: {{ c.riskScore | number:'1.2-2' }}</small></p>
                  </div>
                  <div>
                    <label>Author</label>
                    <p>{{ c.authorName || '-' }}</p>
                    <label style="margin-top:12px">Likes</label>
                    <p>{{ c.likeCount ?? 0 | number }}</p>
                    <label style="margin-top:12px">Video ID</label>
                    <p><a [href]="'https://www.youtube.com/watch?v=' + c.videoId" target="_blank" rel="noopener">{{ c.videoId }}</a></p>
                    <label style="margin-top:12px">Published</label>
                    <p>{{ formatDate(c.publishedAt) }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <div class="pagination" *ngIf="commentTotal > 0">
        <button class="yt-btn" [disabled]="commentPage === 0" (click)="prevComments()">Previous</button>
        <span>Page {{ commentPage + 1 }} / {{ commentTotalPages || 1 }}</span>
        <button class="yt-btn" [disabled]="commentPage >= commentTotalPages - 1" (click)="nextComments()">Next</button>
      </div>
    </div>
  </div>

  <!-- ── SETTINGS TAB ── -->
  <div *ngIf="activeTab === 'config'">
    <div class="content-card config-card" *ngIf="!configLoading">

      <div class="config-save-bar" *ngIf="configSaveResult">{{ configSaveResult }}</div>

      <!-- Module toggle -->
      <div class="config-section">
        <div class="config-section-header">
          <span class="material-icons">power_settings_new</span>
          <h3>Module</h3>
        </div>
        <label class="toggle-row">
          <span>Monitoring enabled</span>
          <input type="checkbox" [(ngModel)]="config.enabled" />
        </label>
      </div>

      <!-- Search settings -->
      <div class="config-section">
        <div class="config-section-header">
          <span class="material-icons">search</span>
          <h3>Search Settings</h3>
        </div>
        <div class="config-row">
          <label>Region code</label>
          <select class="yt-input" [(ngModel)]="config.regionCode">
            <option value="PK">Pakistan (PK)</option>
            <option value="">Global (no restriction)</option>
          </select>
        </div>
        <div class="config-row">
          <label>Max results per keyword</label>
          <input class="yt-input" type="number" [(ngModel)]="config.maxResults" min="1" max="50" />
        </div>
        <div class="config-row">
          <label>Fetch interval</label>
          <select class="yt-input" [(ngModel)]="config.fetchIntervalMs">
            <option *ngFor="let opt of intervalOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <small class="config-hint">Takes effect on next scheduled run</small>
        </div>
      </div>

      <!-- Keywords -->
      <div class="config-section">
        <div class="config-section-header">
          <span class="material-icons">label</span>
          <h3>Search Keywords</h3>
          <small>YouTube is searched once per keyword</small>
        </div>
        <div class="chip-list">
          <span class="chip" *ngFor="let kw of config.keywords">
            {{ kw }}
            <button class="chip-remove" (click)="removeKeyword(kw)">×</button>
          </span>
        </div>
        <div class="chip-input-row">
          <input class="yt-input" [(ngModel)]="newKeyword" placeholder="Add keyword..."
                 (keydown.enter)="addKeyword()" />
          <button class="yt-btn yt-btn-accent" (click)="addKeyword()">Add</button>
        </div>
      </div>

      <!-- Include terms -->
      <div class="config-section">
        <div class="config-section-header">
          <span class="material-icons">check_circle</span>
          <h3>Pakistan Include Terms</h3>
          <small>Video must match at least one term to be saved (whitelisted videos bypass this)</small>
        </div>
        <div class="chip-list chip-list-include">
          <span class="chip chip-include" *ngFor="let t of config.includeTerms">
            {{ t }}
            <button class="chip-remove" (click)="removeIncludeTerm(t)">×</button>
          </span>
        </div>
        <div class="chip-input-row">
          <input class="yt-input" [(ngModel)]="newIncludeTerm" placeholder="e.g. Pakistan, PLRA, لاہور..."
                 (keydown.enter)="addIncludeTerm()" />
          <button class="yt-btn yt-btn-accent" (click)="addIncludeTerm()">Add</button>
        </div>
      </div>

      <!-- Exclude terms -->
      <div class="config-section">
        <div class="config-section-header">
          <span class="material-icons">cancel</span>
          <h3>India / Other Exclude Terms</h3>
          <small>Videos matching these (and no include term) are discarded</small>
        </div>
        <div class="chip-list chip-list-exclude">
          <span class="chip chip-exclude" *ngFor="let t of config.excludeTerms">
            {{ t }}
            <button class="chip-remove" (click)="removeExcludeTerm(t)">×</button>
          </span>
        </div>
        <div class="chip-input-row">
          <input class="yt-input" [(ngModel)]="newExcludeTerm" placeholder="e.g. India, Bharat, Chandigarh..."
                 (keydown.enter)="addExcludeTerm()" />
          <button class="yt-btn yt-btn-accent" (click)="addExcludeTerm()">Add</button>
        </div>
      </div>

      <!-- How the filter works -->
      <div class="config-section config-info">
        <div class="config-section-header">
          <span class="material-icons">info</span>
          <h3>How the filter works</h3>
        </div>
        <ol class="filter-steps">
          <li><strong>regionCode=PK</strong> is sent to YouTube API — first-pass geographic relevance</li>
          <li>Keywords include <code>Pakistan</code> as a qualifier — pushes India results off the top 15</li>
          <li>After fetch: video title + description + channel are checked against include / exclude terms</li>
          <li>A <strong>whitelisted</strong> video always passes — use it for known Pakistani channels you want to track regardless</li>
          <li>A <strong>blacklisted</strong> video is hidden and will never be saved again, even if returned by YouTube</li>
        </ol>
      </div>

      <!-- Save -->
      <div class="config-footer">
        <span *ngIf="config.updatedAt" class="config-updated">Last saved: {{ formatDate(config.updatedAt) }}</span>
        <button class="yt-btn yt-btn-accent" (click)="saveConfig()" [disabled]="configSaving">
          <span class="material-icons">save</span>
          {{ configSaving ? 'Saving...' : 'Save Settings' }}
        </button>
        <button class="yt-btn" (click)="syncNow()" [disabled]="syncing">
          <span class="material-icons">sync</span>
          {{ syncing ? 'Syncing...' : 'Sync Now' }}
        </button>
      </div>
    </div>

    <div class="empty" *ngIf="configLoading">Loading settings...</div>
  </div>

</div>
